(function () {
  'use strict';

  angular.module('sempraWebapp').service('helperService', helperService);

  /** @ngInject */
  function helperService(sessionData) {
    var currentUserId = sessionData.getValue('userId');

    this.checkIfObjectIsEmpty = function (obj) {
      for (var prop in obj) {
        if (obj.hasOwnProperty(prop)) return false;
      }
      return true;
    };

    this.createFileName = function (array) {
      return array.join('-');
    };

    this.setCurrentUserId = function (userId) {
      currentUserId = userId;
    };

    this.getCurrentUserId = function () {
      return currentUserId;
    };

    this.getDevelopAccess = function () {
      return ['68', '82', '84', '101', '111'].includes(this.getCurrentUserId().toString());
    };

    this.orderByRemover = function (orderBy) {
      if (orderBy.indexOf('-') > -1) {
        return orderBy.substring(1);
      } else {
        return orderBy;
      }
    };

    this.setUserDataToLocalStorageOnLogIn = function (userInfo, language) {
      sessionData.setValue(sessionData.Keys.USERNAME_KEY, userInfo.user.email);
      if(language) {
        sessionData.setValue(sessionData.Keys.LANGUAGE_KEY, language);
      }
      sessionData.setValue(
        sessionData.Keys.ACCESS_TOKEN_KEY,
        userInfo.accessToken
      );
      sessionData.setValue(
        sessionData.Keys.REFRESH_TOKEN_KEY,
        userInfo.refreshToken
      );
      sessionData.setValue(sessionData.Keys.USER_ID, userInfo.user.id);
      sessionData.setValue(sessionData.Keys.USER_ROLE_KEY, userInfo.roles);
      sessionData.setValue(
        sessionData.Keys.FIRST_NAME_KEY,
        userInfo.user.firstName
      );
      sessionData.setValue(
        sessionData.Keys.LAST_NAME_KEY,
        userInfo.user.lastName
      );
      sessionData.setValue(
        sessionData.Keys.COUNTRY_CODE,
        userInfo.countryIsoCode
      );
      sessionData.setValue(
        sessionData.Keys.RECEIVE_EMAIL,
        userInfo.receiveEmailNotificationsSelected
      );
    };

      this.showVouchersSideItemByUserId = function () {
          // HardCoded users in a production environment that can see voucher side item
          return [280, 281, 283, 284, 285, 286,
                  305,
                  314,
                  315,
                  318,
                  319,
                  326,
                  331,
                  332,
                  333,
                  334,
                  335,
                  336,
                  337,
                  338,
                  339,
                  340,
                  341,
                  342,
                  343,
                  344,
                  317,628,625,626,623].includes(parseInt(currentUserId));
      };
  }
})();
